mutation ImportDocuments(
  $orderId: ID!
  $documents: [ImportDocumentInput!]!
  $sourceAttachmentTree: JSON
  $nameUpdates: [NameUpdateInput!]
) {
  importDocuments(input: {
    orderId: $orderId
    documents: $documents
    sourceAttachmentTree: $sourceAttachmentTree
    nameUpdates: $nameUpdates
  }) {
    order { id }
    errors
  }
}
